import { Modal as Base } from '../Bootstrap';

export const Modal = {
	props: ['title'],
	mixins: [ Base.Mixin ],
	render: function(h) {
		return (
			<Base.Wrapper>
				<div class="p-4">
					<button class="ft-modal-close" data-dismiss="modal" aria-label="Close">
						<svg class="d-block" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
							<g transform="rotate(45 8 8)">
								<rect x="-2.5" y="7" width="21" height="2" rx=".5" ry=".5"/>
								<rect x="7" y="-2.5" width="2" height="21" rx=".5" ry=".5"/>
							</g>
						</svg>
					</button>
					<div class="ft-modal-title">
						{ this.title }
					</div>
					{ this.$slots.default }
				</div>
			</Base.Wrapper>
		)
	}
}
